import { connect } from 'react-redux';

import { Complaint, IComplaintProps } from './index';
import { resetComplaintState } from '../../store/complaint';
import { EFeedbackComplaint, statusChanger } from '../../store/complaint/feedback_complaint';
import { getComplaints } from '../../store/complaint/get_complaints';

import type { DispatchReduxAction, IState } from '../../store';

type TComplaintStoreProps = Pick<
  IComplaintProps,
  'offer' | 'complaints' | 'isComplaintAdded' | 'isLoading' | 'errorMessage' | 'sendFeedbackStatus' | 'agent'
>;
type TComplaintActionProps = Pick<IComplaintProps, 'getComplaints' | 'resetComplaintState' | 'statusChanger'>;
type TComplaintOwnProps = Pick<IComplaintProps, 'handleOutsideClick'>;

export function mapStateToProps(state: IState): TComplaintStoreProps {
  const { offer, agent } = state.offerData;
  const { status } = state.complaintFeedbackFrom;

  // TODO remove mock data
  if (!offer.categoriesIds) {
    offer.categoriesIds = [1, 100, 110, 111];
  }

  return {
    complaints: state.complaint.complaints,
    errorMessage: state.complaint.errorMessage,
    isComplaintAdded: state.complaint.isComplaintAdded,
    isLoading: state.complaint.isLoading,
    offer,
    sendFeedbackStatus: status,
    agent,
  };
}

export function mapDispatchToProps(dispatch: DispatchReduxAction): TComplaintActionProps {
  return {
    getComplaints: (category: number) => dispatch(getComplaints(category)),
    resetComplaintState: () => dispatch(resetComplaintState()),
    statusChanger: (status: EFeedbackComplaint) => dispatch(statusChanger(status)),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ComplaintContainer = connect<TComplaintStoreProps, TComplaintActionProps, TComplaintOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Complaint);
